export default __webpack_public_path__ + "77c2d5a4c79e1193f01be9652222cb55.jpg";